import { useEffect, useState } from 'react';

export const useScreenHeight = (): number => {
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- FIB-49117
    setScreenHeight(window.innerHeight);
  }, []);

  return screenHeight;
};
